import clsx from 'clsx';
import React from 'react';

export interface ModuleCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export const ModuleCard: React.FC<ModuleCardProps> = ({
  icon,
  title,
  description,
  onClick,
  disabled = false,
  className,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        'group relative flex flex-col items-start gap-4 p-8 bg-white rounded-2xl border-2 transition-all duration-200',
        disabled
          ? 'border-neutral-200 cursor-not-allowed opacity-60'
          : 'border-neutral-200 hover:border-purple-300 hover:shadow-lg cursor-pointer',
        className
      )}
    >
      {/* Icon */}
      <div
        className={clsx(
          'flex items-center justify-center w-16 h-16 rounded-xl transition-colors',
          disabled ? 'bg-neutral-100 text-neutral-400' : 'bg-purple-50 text-purple-600'
        )}
      >
        {icon}
      </div>

      {/* Content */}
      <div className="flex flex-col items-start gap-2 text-left">
        <h3
          className={clsx(
            'text-xl font-semibold transition-colors',
            disabled ? 'text-neutral-400' : 'text-purple-600 group-hover:text-purple-700'
          )}
        >
          {title}
        </h3>
        <p className="text-base text-neutral-600 leading-relaxed">{description}</p>
      </div>
    </button>
  );
};
